var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m228.8078,109.6665c-6.5803,0-11.9146,5.3349-11.9146,11.9146s5.3343,11.9163,11.9146,11.9163,11.9157-5.3349,11.9157-11.9163-5.3349-11.9146-11.9157-11.9146Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m175.8347,124.9468c-27.5999,0-50.055,22.4534-50.055,50.0532s22.4551,50.0538,50.055,50.0538,50.0532-22.4551,50.0532-50.0538-22.4551-50.0532-50.0532-50.0532Zm0,82.116c-17.6809,0-32.0639-14.3824-32.0639-32.0627s14.383-32.0622,32.0639-32.0622,32.061,14.3818,32.061,32.0622-14.3824,32.0627-32.061,32.0627Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m215.5709,276.6242h-81.1457c-33.6631,0-61.0493-27.3862-61.0493-61.0493v-81.1498c0-33.6637,27.3862-61.0493,61.0493-61.0493h81.1457c33.6631,0,61.0533,27.3856,61.0533,61.0493v81.1498c0,33.6631-27.3902,61.0493-61.0533,61.0493Zm-81.1457-184.1262c-23.1209,0-41.9283,18.8068-41.9283,41.9271v81.1498c0,23.1209,18.8074,41.9283,41.9283,41.9283h81.1457c23.1209,0,41.9312-18.8074,41.9312-41.9283v-81.1498c0-23.1203-18.8103-41.9271-41.9312-41.9271h-81.1457Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBInstagram);
export default __webpack_public_path__ + "static/media/B_Instagram.04d5c63d7334dba9a861f460459fdaf3.svg";
export { ForwardRef as ReactComponent };